const setToken = (token: string) => {
  localStorage.setItem("token", token);
};
const getToken = () => {
  return localStorage.getItem("token");
};

const removeToken = () => {
  localStorage.removeItem("token");
};

export const setStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const getStorage = (key: string) => {
  if (!key) return;
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};

export { setToken, getToken, removeToken };
